import { EappEnum } from './eAppEnum';

// PVQ Dropdown values
export const militaryDisciplinaryProcedureNamesPvq = [
  'Letter of Admonishment',
  'Letter of Reprimand',
  'Article 15 (of the UCMJ)',
  'Court-Martial',
  'Other',
];

// PVQ Dropdown values
export const civilianMilitaryOptions = [
  'Civilian',
  'Military',
];

// PVQ dropdown values
export const civilianMilitaryAdditionalOptions = [
  'Civilian',
  'Military member',
];

// PVQ Dropdown values
export const disciplineOptions = [
  'Written Warning',
  'Official Counseling',
  'Official Reprimand',
  'Suspended',
  'Demoted - Reduction in grade',
  'Demoted - Reduction in pay',
  'Removed from position, but not from employment',
  'Other',
];

// PVQ Dropdown
export const disciplineSentenceOptions = new EappEnum([
  {
    i18nField: 'reductioninrank', key: 'reductioninrank', value: 'ReductionInRank', text: 'Reduction in rank'
  },
  {
    i18nField: 'forfeitureofpay', key: 'forfeitureofpay', value: 'ForfeitureOfPay', text: 'Forfeiture of pay'
  },
  {
    i18nField: 'suspendedfromduty', key: 'suspendedfromduty', value: 'SuspendedFromDuty', text: 'Suspended from duty'
  },
  {
    i18nField: 'detention', key: 'detention', value: 'Detention', text: 'Detention'
  },
  {
    i18nField: 'restrictions', key: 'restrictions', value: 'Restrictions', text: 'Restrictions'
  },
  {
    i18nField: 'extraduties', key: 'extraduties', value: 'ExtraDuties', text: 'Extra duties'
  },
  {
    i18nField: 'imprisonment', key: 'imprisonment', value: 'Imprisonment', text: 'Imprisonment'
  },
  {
    i18nField: 'other', key: 'other', value: 'Other', text: 'Other'
  },
]);

// PVQ Dropdown values
export const courtMartialTypes = [
  'Summary',
  'Special',
  'General',
];
